export * from "./annual_sales_type";
export * from "./apply_status";
export * from "./capital_type";
export * from "./category";
export * from "./employee_num_type";
export * from "./nyu_month_type";
export * from "./prefecture";
export * from "./sale_status";
export * from "./tax";
export * from "./thread_send_receive_type";

/** 会社のソート順 */
export const enum SortOrderTypePublicCorps {
  /** 新着順（商品更新日時の降順） */
  UPDARE_DATE_NEW = "update_date_new",
  /** 会社名昇順 */
  CORP_NAME_ASC = "corp_name_asc",
  /** 会社名降順 */
  CORP_NAME_DESC = "corp_name_desc",
  /** 資本金が多い順 */
  CAPITAL_HIGH = "capital_high",
}

/** 商品のソート順 */
export const enum SortOrderTypePublicItems {
  /** 新着順（商品更新日時の降順） */
  UPDARE_DATE_NEW = "update_date_new",
  /** 会社名昇順 */
  CORP_NAME_ASC = "corp_name_kana_asc",
  /** 会社名降順 */
  CORP_NAME_DESC = "corp_name_kana_desc",
  /** 価格が高い順 */
  PRICE_HIGH = "price_high",
  /** 価格が低い順 */
  PRICE_LOW = "price_low",
}

/** 出品一覧のソート順 */
export const enum SortOrderTypeApplyItems {
  /** 更新日が新しい順（更新日時の降順） */
  UPDARE_DATE_NEW = "update_date_new",
  /** 更新日が古い順（更新日時の昇順） */
  UPDARE_DATE_OLD = "update_date_old",
  /** 価格が高い順（価格の降順） */
  PRICE_HIGH = "price_high",
  /** 価格が低い順（価格の昇順） */
  PRICE_LOW = "price_low",
}

/** お気に入り商品のソート順 */
export const enum SortOrderTypeFavoriteItems {
  /** 追加日が新しい順 */
  ADD_DATE_NEW = "add_date_new",
  /** 追加日が古い順 */
  ADD_DATE_OLD = "add_date_old",
  /** 価格が高い順 */
  PRICE_HIGH = "price_high",
  /** 価格が低い順 */
  PRICE_LOW = "price_low",
}

/** お気に入り会社のソート順 */
export const enum SortOrderTypeFavoriteCorps {
  /** 追加日が新しい順 */
  ADD_DATE_NEW = "add_date_new",
  /** 追加日が古い順 */
  ADD_DATE_OLD = "add_date_old",
  /** 会社名の昇順 */
  CORP_NAME_ASC = "corp_name_asc",
  /**会社名の降順 */
  CORP_NAME_DESC = "corp_name_desc",
  /**資本金が多い順 */
  CAPITAL_MANY = "capital_many",
}

/** 支払い条件 */
export const enum PaymentTerms {
  /** 1:翌月末 */
  _1_YOKU_GETSU = 1,
  /** 2:翌々月末 */
  _2_YOKUYOKU_GETSU,
  /** 3:３ヶ月末 */
  _3_3MONTHS,
}

/** 支払い情報 */
export const PaymentTermsInfo = {
  [PaymentTerms._1_YOKU_GETSU]: {
    payment_type_id: PaymentTerms._1_YOKU_GETSU,
    payment_type_name: '翌月',
    pay_month: 1,
  },
  [PaymentTerms._2_YOKUYOKU_GETSU]: {
    payment_type_id: PaymentTerms._2_YOKUYOKU_GETSU,
    payment_type_name: '翌々月',
    pay_month: 2,
  },
  [PaymentTerms._3_3MONTHS]: {
    payment_type_id: PaymentTerms._3_3MONTHS,
    payment_type_name: '３ヶ月',
    pay_month: 3,
  },
}

export const enum PER_PAGE_TYPES {
  DEFAULT = 10,
  _10 = 10,
  _25 = 25,
  _50 = 50,
  _100 = 100,
}

export const enum  JOHOKU_ACCOUNT_TYPE {
  NO_ACCOUNT,
  HAS_ACCOUNT
}

export const JOHOKU_ACCOUNT =  {
  bank_cd: "1351",
  bank_name: "城北信用金庫",
}